import { graphql } from 'react-relay';

export const checkBankAccount = graphql`
  mutation checkBankAccountMutation($bankCode: BankCode!, $account: String!) {
    checkBankAccount(bankCode: $bankCode, account: $account) {
      result
      errors {
        code
      }
      name
    }
  }
`;
